import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Checkbox, Button, Modal } from 'antd';

export const SumConditions = ({
  onAddConditions,
  dataSorted,
  loading,
  questionsSumConditions,
  setQuestionsSumConditions,
  isOpen,
  onClose
}) => {
  const { t } = useTranslation();

  const onChange = (e, question) => {
    let newConditions;

    if (e.target.checked) {
      newConditions = [...questionsSumConditions, question.id];
    } else {
      newConditions = questionsSumConditions.filter((a) => a !== question.id);
    }

    setQuestionsSumConditions(newConditions);
  };

  const onAdd = () => {
    onAddConditions();
  };

  if (loading) return <div>{t('Loading')}...</div>;

  return (
    <Modal
      title={'Select sum conditions'}
      width={700}
      style={{
        top: 20
      }}
      okText={'Add'}
      footer={null}
      open={isOpen}
      // onOk={onAddAnswers}
      onCancel={() => {
        onClose();
      }}
    >
      <Box>
        {dataSorted &&
          dataSorted.length &&
          dataSorted.map((section) => (
            <Fragment key={section.id}>
              {section && (
                <SectionBox>
                  <div>{section.section} (section)</div>
                  {section.questionGroups &&
                    section.questionGroups.length &&
                    section.questionGroups.map((group) => (
                      <Fragment key={group.id}>
                        {group && (
                          <GroupBox>
                            <div>{group.title} (group)</div>
                            {group.questions &&
                              group.questions.length &&
                              group.questions.map((question) => (
                                <Fragment key={question.id}>
                                  {question && (
                                    <QuestionBox>
                                      <Checkbox
                                        onChange={(e) => onChange(e, question)}
                                        checked={
                                          questionsSumConditions &&
                                          questionsSumConditions.includes(question.id)
                                        }
                                      >
                                        {question.question}
                                      </Checkbox>
                                    </QuestionBox>
                                  )}
                                </Fragment>
                              ))}
                          </GroupBox>
                        )}
                      </Fragment>
                    ))}
                </SectionBox>
              )}
            </Fragment>
          ))}
      </Box>
      <BtnBox>
        <Button onClick={onAdd} type='primary' style={{ marginTop: '30px' }}>
          {t('Add conditions')}
        </Button>
      </BtnBox>
    </Modal>
  );
};

const Box = styled.div`
  height: 600px;
  overflow-y: scroll;
`;

const QuestionBox = styled.div`
  margin-bottom: 10px;
  padding-left: 15px;
`;

const GroupBox = styled.div`
  margin-bottom: 10px;
  padding-left: 15px;
`;

const SectionBox = styled.div`
  margin-bottom: 10px;
`;

const BtnBox = styled.div`
  text-align: right;
`;
